namespace Ir.Components.Workbook.WorkbookCopy {

    interface IWorkbookCopyViewModel {
        workbookNameOptions: DevExpress.ui.dxTextBox.Properties;
        saveOptions: DevExpress.ui.dxCheckBox.Properties;
        copyEmailsOptions: DevExpress.ui.dxCheckBox.Properties;
        tabsOptions: DevExpress.ui.dxDataGrid.Properties;
    }

    interface IWorkbookCopyParams {
        workbookName: string;
        tabWidgetDependencies: any;

        callback: (obj) => boolean;
    }

    export function getViewModel(this: IWorkbookCopyViewModel, params: IWorkbookCopyParams) {
        let saveComponent: DevExpress.ui.dxCheckBox = null
        let copyEmailsComponent: DevExpress.ui.dxCheckBox = null
        let workbookNameComponent: DevExpress.ui.dxTextBox = null
        let tabsComponent: DevExpress.ui.dxDataGrid = null

        this.workbookNameOptions = {
            value: params.workbookName,
            onInitialized(e) {
                workbookNameComponent = e.component;
            }
        };

        this.copyEmailsOptions = {
            value: false,
            text: 'Copy Scheduled Emails',
            onInitialized(e) {
                copyEmailsComponent = e.component;   
            },
            onValueChanged: function (e) {
                if (e.value) {
                    saveComponent.option("value", true);
                }

                saveComponent.option("disabled", e.value);
            }
        };

        this.saveOptions = {
            value: true,
            text: 'Save Workbook',
            onInitialized(e) {
                saveComponent = e.component;
            }
        };

        this.tabsOptions = {
            keyExpr: "id",
            dataSource: workbook.workbookConfig.tabs(),
            columns: [
                { dataField: "id", visible: false },
                { dataField: "name", caption: "Tab Name" },
            ],
            height: 165,
            selection: {
                mode: 'multiple',
                showCheckBoxesMode: 'always'
            },
            selectedRowKeys: workbook.workbookConfig.tabs().map(x => x.id),
            showBorders: true,
            paging: {
                enabled: false
            },
            onInitialized(e) {
                tabsComponent = e.component;
                tabsComponent.selectAll();
            },
            onSelectionChanged: function (e) {
                if (workbook.workbookConfig.tabs().length > 0 && e.selectedRowKeys.length !== workbook.workbookConfig.tabs().length) {
                    copyEmailsComponent.option("value", false);
                    copyEmailsComponent.option("disabled", true);
                }
                else {
                    copyEmailsComponent.option("disabled", false);
                }

                if (e.currentSelectedRowKeys.length > 0) {
                    var selectRows = [];
                    e.currentSelectedRowKeys.forEach(function (key) {
                        if (params.tabWidgetDependencies[key]) {
                            params.tabWidgetDependencies[key].forEach(function (tabId) {
                                if (selectRows.indexOf(tabId) === -1 && e.selectedRowKeys.indexOf(tabId) === -1) {
                                    selectRows.push(tabId);
                                }
                            });
                        }
                    });

                    if (selectRows.length > 0) {
                        e.component.selectRows(selectRows, true);
                    }
                }
            }.bind(this)
        }

        params.callback({
            save: function () {
                let updateModel = {
                    workbookId: workbook.workbookConfig.workbookId(),
                    workbookName: workbookNameComponent.option("value"),
                    copyScheduledEmails: false,
                    save: false,
                    tabs: []
                };

                let saveNewCopy = function () {
                    updateModel.workbookName = workbookNameComponent.option("value");
                    updateModel.copyScheduledEmails = copyEmailsComponent.option("value");
                    updateModel.save = saveComponent.option("value");
                    updateModel.tabs = tabsComponent.getSelectedRowKeys();

                    if (updateModel.tabs.length === 0) {
                        DevExpress.ui.notify("It is necessary to have at least one tab selected to create a copy of the workbook", "error", 3000);
                        return;
                    }

                    let o = {
                        url: urlConfigs.tabs + "copy",
                        data: updateModel,
                        dataType: "json",
                        async: false
                    } as RequestServerParams;
                    o.successFunction = function (result) {
                        document.location.href = result;
                    }.bind(this);
                    o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                        errorItem.userMessage = "Failed to copy workbook";
                        irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                    };

                    irGlobal.requestServer(o);
                }

                if (!updateModel.workbookName || updateModel.workbookName.trim() === "") {
                    DevExpress.ui.notify("Workbook Name is required", "error", 3000);
                    return;
                }

                let o = {
                    url: urlConfigs.tabs + "workbookNameUnique",
                    data: updateModel,
                    dataType: "json",
                    async: false
                } as RequestServerParams;
                o.successFunction = function (result) {
                    if (result) {
                        saveNewCopy();
                    }
                    else {
                        DevExpress.ui.notify("Duplicated name, please choose another name", "error", 3000);
                    }
                }.bind(this);
                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to check workbook name";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                };

                irGlobal.requestServer(o);
            }
        })
    }
}